import { Tag } from "@design-system/Tag/Tag";
import styles from "./AgentChat.module.scss";

interface Props {
    suggestions: string[];
    onSelect: (suggestion: string) => void;
}

export const FollowUpChips: React.FC<Props> = ({ suggestions, onSelect }) => {
    if (suggestions.length === 0) {
        return null;
    }

    return (
        <div className={styles.followUps}>
            {suggestions.map((suggestion, index) => (
                <Tag
                    key={index}
                    size="sm"
                    color="neutral"
                    onClick={() => onSelect(suggestion)}
                >
                    {suggestion}
                </Tag>
            ))}
        </div>
    );
};
